import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  ClassicEditor,
  Bold,
  Underline,
  Strikethrough,
  Essentials,
  Italic,
  Paragraph,
  Undo,
  Heading,
  HorizontalLine,
  List,
  ListProperties,
  Alignment,
  Indent,
  IndentBlock,
  Link,
  CodeBlock,
  BlockQuote,
  Table,
  Image,
  ImageBlock,
  ImageInline,
  ImageUpload,
  ImageToolbar,
  ImageCaption,
  ImageResize,
  AutoImage,
  ImageStyle,
  LinkImage,
  TableToolbar,
  TableCellProperties,
  TableProperties,
  SpecialCharacters,
  SpecialCharactersEssentials,
  RemoveFormat,
  MediaEmbed,
  ShowBlocks,
  Font,
  SourceEditing,
  SimpleUploadAdapter,
  GeneralHtmlSupport,
} from "ckeditor5";
import "ckeditor5/ckeditor5.css";
import { Box } from "@mui/material";

const CKEditorField = ({ value, onChange, uploadUrl }) => {
  const token = localStorage.getItem("token");

  return (
    <CKEditor
      editor={ClassicEditor}
      data={value}
      onChange={(event, editor) => {
        onChange(editor.getData());
      }}
      config={{
        licenseKey: "GPL",
        toolbar: {
          items: [
            "undo", "redo", "|",
            "showBlocks", "sourceEditing", "heading", "|",
            "fontSize", "fontFamily", "fontColor", "fontBackgroundColor", "removeFormat", "|",
            "bold", "italic", "underline", "strikethrough", "|",
            "insertImage", "mediaEmbed", "|",
            "link", "insertTable", "blockQuote", "codeBlock", "|",
            "horizontalLine", "specialCharacters", "|",
            "alignment", "bulletedList", "numberedList", "indent", "outdent",
          ],
          shouldNotGroupWhenFull: true,
        },
        plugins: [
          Bold, Essentials, Italic, Underline, Strikethrough, Paragraph,
          Undo, Heading, HorizontalLine, List, ListProperties, Alignment,
          Indent, IndentBlock, Link, Table, Image, ImageBlock, ImageUpload,
          ImageInline, ImageToolbar, ImageCaption, ImageResize, ImageStyle,
          LinkImage, AutoImage, CodeBlock, BlockQuote, TableToolbar,
          TableCellProperties, TableProperties, SpecialCharacters,
          SpecialCharactersEssentials, RemoveFormat, MediaEmbed, ShowBlocks,
          Font, SourceEditing, SimpleUploadAdapter, GeneralHtmlSupport,
        ],
        image: {
          toolbar: [
            "imageStyle:wrapText", "imageStyle:breakText", "|",
            "toggleImageCaption", "imageTextAlternative", "|", "linkImage",
          ],
          insert: { integrations: ["upload", "url"] },
        },
        mediaEmbed: {
          previewsInData: true,
          // For twitter, instagram, google maps, etc. have to add custom providers.
        },  
        table: {
          contentToolbar: [
            "tableColumn", "tableRow", "mergeTableCells",
            "tableProperties", "tableCellProperties",
          ],
        },
        ...(uploadUrl && {
          simpleUpload: {
            uploadUrl,
            withCredentials: false,
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        }),
        htmlSupport: {
          allow: [{ name: /.*/, attributes: true, classes: true, styles: true }],
          disallow: [{ name: "script" }],
        },
      }}
    />
  );
};

export default CKEditorField;